import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "@/lib/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { toast } from "@/components/ui/use-toast";

export const submitEnterpriseSalesForm = createAsyncThunk(
  "enterpriseSales/submitForm",
  async (formData, { rejectWithValue }) => {
    try {
      await addDoc(collection(db, "enterpriseSalesContacts"), {
        ...formData,
        submittedAt: serverTimestamp(),
        createdAt: serverTimestamp(),
      });
      toast({
        title: "Inquiry Sent!",
        description:
          "Our Enterprise Sales team will contact you within 24 hours. Thank you!",
        variant: "default",
      });
    } catch (error) {
      toast({
        title: "Submission Error",
        description:
          error.message ||
          "Could not send your inquiry. Please try again later.",
        variant: "destructive",
      });
      return rejectWithValue(
        error.message || "Could not send your inquiry. Please try again later."
      );
    }
  }
);
